module.exports = __webpack_public_path__ + "burn.svg?c6d32077d715eb7610612f841d63d092";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/burn.svg
// module id = 245
// module chunks = 0